import React, { useState } from "react";
import LinearProgress from "@mui/material/LinearProgress";
import Box from "@mui/material/Box";

import { sortImages } from "../../../utils/images";
import ImageModal from "../../../components/images/ImageModal";
import useNotification from "../../../hooks/notification";
import { useAssets } from "../../../contexts/assets";
import useImageUploadWithAttachments from "../../../hooks/useImageUploadWithAttachments";

import ImageDND from "./ImageDND";
import ImagesSlider from "./ImagesSlider";

export default function Images({ asset }) {
  const { updateImage, bulkCreateImages, removeImage } = useAssets();
  const { notifyError } = useNotification();
  const [loading, setLoading] = useState(false);
  const list = sortImages(asset?.images);
  const [open, setOpen] = useState(null);
  const defaultIndex = list.findIndex(v => v.default);
  const [index, setIndex] = useState(defaultIndex === -1 ? 0 : defaultIndex);

  // Use custom hook that automatically syncs shipment item attachments
  const handleBulkCreateImages = useImageUploadWithAttachments(asset, bulkCreateImages);

  const handleOpen = () => {
    if (list.length > 0) {
      setOpen(true);
    }
  };

  const handleUpload = images => {
    setLoading(true);
    handleBulkCreateImages({
      variables: { assetId: asset.id, images },
      onSuccess: () => {
        setLoading(false);
      },
      onFailure: errors => {
        notifyError(errors);
        setLoading(false);
      },
    });
  };

  const handleRemove = data => {
    setIndex(0);
    removeImage(data);
  };

  return (
    <>
      <Box
        position="relative"
        onClick={handleOpen}
        sx={{
          width: { xs: "90%", sm: "50%", md: "100%" }, // Adjusts image frame width based on screen size
          margin: "0 auto",
        }}
      >
        {list.length === 0 && (
          <>
            {loading && <LinearProgress />}
            <ImageDND onDrop={handleUpload} />
          </>
        )}
        <ImagesSlider list={list} index={index} onChangeIndex={setIndex} />
      </Box>
      {open && list[index] && (
        <ImageModal
          open
          closeOnSave={true}
          selectedId={list[index].id}
          asset={asset}
          images={list}
          onClose={() => setOpen(false)}
          onRemove={handleRemove}
          onUpdate={updateImage}
          onCreate={handleBulkCreateImages}
        />
      )}
    </>
  );
}
